<script setup lang="ts">
    import type { CustomField } from "common";
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const { field } = defineProps<{
        field: CustomField & { type: "string" };
    }>();

    onMounted(() => {
        fieldModel.value = orderStore.currentOrder.customFields.find(
            (cf) => cf.id === field.id,
        )?.value as string | undefined;
    });

    const fieldModel = ref<string | undefined>(undefined);

    const pushField = () => {
        orderStore.helpers.setCustomField(field.id, fieldModel.value as string);
    };

    const r$ = orderStore.validation.r$;

    const regleField = computed(() =>
        r$.$fields.customFields.$each.find((rf) => rf.$value.id === field.id),
    );
</script>
<template>
    <shared-labeled-field
        v-slot="{ ariaLabelledby }"
        :label="field.label + (field.required ? ' *' : '')"
    >
        <VTextarea
            v-model="fieldModel"
            rows="3"
            :aria-labelledby="ariaLabelledby"
            :placeholder="field.placeholder"
            :error-messages="regleField?.$fields.value.$errors"
            @focusout="regleField?.$fields.value.$touch"
            @update:focused="pushField"
        />
    </shared-labeled-field>
</template>
